import React from 'react';
import { Map, TileLayer, Polygon } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

// Simple farm boundary for testing
const farmBoundary = [
  [-34.00256677544119, 19.491489831450753],
  [-34.00345620472669, 19.49157566213923],
  [-34.003349473704205, 19.492433969023995],
  [-34.00256677544119, 19.49230522299128],
  [-34.00256677544119, 19.491489831450753]
];

// Calculate center of polygon
function calculateCenter(coordinates) {
  var lats = [];
  var lngs = [];
  
  for (var i = 0; i < coordinates.length; i++) {
    lats.push(coordinates[i][0]);
    lngs.push(coordinates[i][1]);
  }
  
  var sumLat = 0;
  var sumLng = 0;
  
  for (var j = 0; j < lats.length; j++) {
    sumLat += lats[j];
  }
  
  for (var k = 0; k < lngs.length; k++) {
    sumLng += lngs[k];
  }
  
  var centerLat = sumLat / lats.length;
  var centerLng = sumLng / lngs.length;
  
  return [centerLat, centerLng];
}

const defaultCenter = calculateCenter(farmBoundary);

function SimpleMapTest() {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Simple Leaflet Map Test</h1>
      <div style={{ height: '500px', width: '100%' }}>
        <Map center={defaultCenter} zoom={16} style={{ height: '100%', width: '100%' }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Polygon 
            positions={farmBoundary}
            color="#4CAF50"
            weight={3}
            fillColor="#A5D6A7"
            fillOpacity={0.4}
          />
        </Map>
      </div>
      <p>This is a minimal test of the Leaflet map functionality.</p>
    </div>
  );
}

export default SimpleMapTest;
